$(function (ws) {
    'use strict';

    ws.views.resellerLookup = Backbone.View.extend({
        events: {
            change: 'triggerChange'
        },

        /**
         * Initializes the component.
         */
        initialize() {
            this.salesOrg = this.$el.data('salesOrg');
            this.$el = this.$el.children(':first');
            let url = '';
            if (sitePath === '/quote') {
                url = globals.path.api.quoting.bulkResellerSearchUrl;
            } else {
                url = globals.path.api.orderentry.mergeQuoteResellerSearch;
            }

            this.initAjaxSelect(this.$el, url);
            this.eventAgg.on('salesOrg:change', this.updateReseller.bind(this));
        },

        triggerChange() {
            this.eventAgg.trigger('resellerLookup:change', this.$el.val(), this.$el);
        },

        /**
         * This function will reset reseller dropdown on change of sales org
         */
        updateReseller: function (salesOrg, $changedEvent) {
            this.salesOrg = salesOrg;
            if (salesOrg && salesOrg.length > 1) {
                this.$el.select2('enable');
            }

            this.$el.val('').trigger('change');
            this.triggerChange();
        },

        /**
        *
        * @param {*} $inputSelectbox
        * @param {*} ajaxUrl
        */
        initAjaxSelect: function ($inputSelectbox, ajaxUrl) {
           if (!this.salesOrg) {
               $inputSelectbox.select2('enable', false);
           }

           $inputSelectbox.select2({
               ajax: {
                   url: ajaxUrl,
                   dataType: 'json',
                   delay: 400,
                   /**
                    *
                    * @param {*} params
                    * @returns {{searchText: *}}
                    */
                   data: params => {
                       return {
                           resellerId: params.term,
                           salesOrg: this.salesOrg,
                           page: params.page
                       };
                   },

                   /**
                    *
                    * @param {*} data
                    * @returns {{results: Array}}
                    */
                   processResults: function (data, params) {
                       params.page = params.page || 1;

                       return {
                           results: _.map(data, function (item) {
                               return {
                                   id: item.uid,
                                   text: item.uid + '-' + item.name
                               };
                           })
                       };
                   },

                   cache: true
               },
                minimumInputLength: 2,
                language: {
                    noResults: function() {
                        return "<span class='select2-custom-error error-message'>The partner account is not recognized as a valid reseller. Please search using the partner's name. If no account appears, contact the MDM team for further assistance</span>";
                    }
                },
                escapeMarkup: function (markup) {
                    return markup;
                }
           }).on('select2:open', function (e) {
           });
       }
    });
}(westcon));
